import { Alert, AlertTitle } from "@mui/material";
import { dismissSafetyWarning } from "portal/state/farmExplorer";
import { useDispatch } from "react-redux";
import { useFarmExplorer, useSelf } from "portal/state/store";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

interface FarmEditSafetyWarningProps {
  className?: string;
}

/**
 * Shown at the top of every page that can change farm geometry, to customers
 * only. Field, boundary, and obstacle edits decide where autonomous equipment
 * drives, and nobody at Carbon reviews them before a robot uses them, so the
 * person editing has to own the safety of the result. Closing it hides it
 * until the next visit.
 */
export const FarmEditSafetyWarning: FC<FarmEditSafetyWarningProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isInternal } = useSelf();
  const { safetyWarningDismissed } = useFarmExplorer();
  if (isInternal || safetyWarningDismissed) {
    return;
  }
  return (
    <Alert
      severity="warning"
      variant="filled"
      className={className}
      onClose={() => dispatch(dismissSafetyWarning())}
    >
      <AlertTitle>{t("views.farms.safetyWarning.title")}</AlertTitle>
      {t("views.farms.safetyWarning.body")}
    </Alert>
  );
};
